import React, { useEffect, useState, useRef } from 'react';
import './Footer.css'
import { Link as Anchor } from 'react-router-dom';
import logo from '../../images/logo.png'
import libroReclamacionesLogo from '../../images/libro-reclamaciones-blanco.png';
import baseURL from '../url';
import TikTokIcon from '../TikTokIcon/TikTokIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUser,
    faMapMarkerAlt,
    faIdCard,
    faUserPlus,
    faCalendarAlt,
    faInfoCircle,
    faFileContract,
    faUserShield,
    faChild,
    faUndo
} from '@fortawesome/free-solid-svg-icons';
import useSiteConfig from '../useSiteConfig';

export default function Footer() {
    const { logo: siteLogo, color_footer, footer_bg_image, footer_bg_opacity } = useSiteConfig();
    const [categorias, setCategorias] = useState([]);
    const [contactos, setContactos] = useState([]);
    const [quienesSomos, setQuienesSomos] = useState([]);
    const [politicas, setPoliticas] = useState([]);

    useEffect(() => {
        cargarProductos();
    }, []);

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const categoriasMap = new Map();
                data.productos.forEach(producto => {
                    const categoria = producto.categoria;
                    if (categoriasMap.has(categoria)) {
                        categoriasMap.get(categoria).push(producto);
                    } else {
                        categoriasMap.set(categoria, [producto]);
                    }
                });
                const categoriasArray = Array.from(categoriasMap, ([categoria, productos]) => ({ categoria, productos }));
                setCategorias(categoriasArray?.slice(0, 3));
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    useEffect(() => {
        cargarContacto();
        cargarQuienesSomos();
        cargarPoliticas();
    }, []);

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const lista = data.contacto || [];
                setContactos(lista[0] || {});
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const cargarQuienesSomos = () => {
        fetch(`${baseURL}/quienesSomosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setQuienesSomos(data.quienesSomos || []);
            })
            .catch(error => console.error('Error al cargar Quiénes Somos:', error));
    };

    const cargarPoliticas = () => {
        fetch(`${baseURL}/politicasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const lista = data.politicas || [];
                const activas = lista.filter(p => p.estado !== 'inactivo');
                setPoliticas(activas.length > 0 ? activas : lista);
            })
            .catch(error => console.error('Error al cargar políticas:', error));
    };

    const abreviarTitulo = (p) => {
        const tit = (p.titulo || '').toUpperCase();
        if (tit.includes('TÉRMINOS') || tit.includes('TERMINOS')) return 'Términos y Condiciones';
        if (tit.includes('DATOS') || tit.includes('PRIVACIDAD')) return 'Protección de Datos';
        if (tit.includes('EXPLOTACIÓN') || tit.includes('MENOR') || tit.includes('NIÑOS')) return 'Protección al Menor';
        if (tit.includes('CANCELACIÓN') || tit.includes('COBRO') || tit.includes('REEMBOLSO')) return 'Cancelación y Reembolso';
        if (p.categoria && p.categoria !== 'General') return p.categoria;
        return p.titulo.replace(/^[I|V|X]+\.?\s*[-–—]?\s*/i, '').slice(0, 26);
    };

    const iconoPolitica = (p) => {
        const tit = (p.titulo || '').toUpperCase();
        if (tit.includes('DATOS') || tit.includes('PRIVACIDAD')) return faUserShield;
        if (tit.includes('MENOR') || tit.includes('NIÑOS')) return faChild;
        if (tit.includes('CANCELACIÓN') || tit.includes('REEMBOLSO')) return faUndo;
        return faFileContract;
    };

    const politicasAMostrar = politicas.length > 0 ? politicas : [
        { idPolitica: 1, titulo: 'I. TÉRMINOS Y CONDICIONES DE USO DEL CANAL DIGITAL' },
        { idPolitica: 2, titulo: 'II. POLÍTICAS PROTECCIÓN DE DATOS PERSONALES' },
        { idPolitica: 3, titulo: 'III. CONDUCTAS VINCULADAS A LA EXPLOTACIÓN SEXUAL DE NIÑOS, NIÑAS Y ADOLESCENTES' },
        { idPolitica: 4, titulo: 'IV. POLÍTICAS DE COBRO, CANCELACIÓN Y REEMBOLSO' },
    ];

    const telefonoLimpio = (contactos.telefono || '').replace(/\D/g, '');

    return (
        <div
            className='FooterContain'
            style={{
                backgroundColor: color_footer || undefined,
                '--footer-bg-image': footer_bg_image ? `url("${footer_bg_image}")` : 'none',
                '--footer-bg-opacity': footer_bg_opacity !== undefined ? footer_bg_opacity : '0.70'
            }}
        >
            <div className='footerText'>
                <div className='footerLogoBrand'>
                    <Anchor to='/' className='footerLogoLink'>
                        <img src={siteLogo || logo} alt="logo" onError={(e) => { e.target.src = logo; }} />
                    </Anchor>
                    <div className='footerBrandTitles'>
                        <h2>
                            {contactos.nombre}
                        </h2>
                        {contactos.representante && (
                            <span className='footerSubInfo footerRepresentante'>
                                {contactos.representante.toLowerCase().includes('representante')
                                    ? contactos.representante
                                    : `${contactos.representante}`}
                            </span>
                        )}
                        {contactos.ruc && (
                            <span className='footerSubInfo footerRuc'>
                                {contactos.ruc.toLowerCase().includes('ruc')
                                    ? contactos.ruc
                                    : `RUC: ${contactos.ruc}`}
                            </span>
                        )}
                    </div>
                </div>

                {/* Enlace hacia la nueva página con el nombre registrado en Quiénes Somos */}
                {quienesSomos && quienesSomos.length > 0 && (
                    <div className='footerQuienesSomosWrapper'>
                        {quienesSomos.map((qs) => (
                            <Anchor
                                key={qs.idQuienesSomos}
                                to="/quienes-somos"
                                className='btnFooterQuienesSomos'
                                title={`Conoce más sobre ${qs.titulo}`}
                            >
                                <FontAwesomeIcon icon={faInfoCircle} /> {qs.titulo}
                            </Anchor>
                        ))}
                    </div>
                )}

                <div className='socials'>
                    {contactos.instagram && <Anchor to={contactos.instagram} target="_blank" rel="noopener noreferrer"><i className='fa fa-instagram'></i></Anchor>}
                    {contactos.telefono && <Anchor to={`tel:${contactos.telefono}`} target="_blank" rel="noopener noreferrer"><i className='fa fa-whatsapp'></i></Anchor>}
                    {contactos.facebook && <Anchor to={contactos.facebook} target="_blank" rel="noopener noreferrer"><i className='fa fa-facebook'></i></Anchor>}
                    {contactos.tiktok && (
                        <Anchor to={contactos.tiktok.startsWith('http') ? contactos.tiktok : `https://www.tiktok.com/@${contactos.tiktok.replace(/^@/, '')}`} target="_blank" rel="noopener noreferrer" title="TikTok">
                            <TikTokIcon size={16} />
                        </Anchor>
                    )}
                    <Anchor to={`/dashboard`} >
                        <FontAwesomeIcon icon={faUser} />
                    </Anchor>
                </div>
            </div>

            <div className='footerText'>
                <h3>Contacto</h3>
                <Anchor to={`mailto:${contactos.email}`} target="_blank" rel="noopener noreferrer">{contactos.email}</Anchor>
                <Anchor to={`tel:${contactos.telefono}`} target="_blank" rel="noopener noreferrer">{contactos.telefono}</Anchor>
                {/* Libro de Reclamaciones Digital en reemplazo de dirección */}
                <div className='footerLibroWrap'>
                    <Anchor
                        to="/libro-de-reclamaciones"
                        className="footerLibroLink"
                        title="Libro de Reclamaciones Digital"
                    >
                        <img
                            src={libroReclamacionesLogo}
                            alt="Libro de Reclamaciones Digital"
                            className="footerLibroImg"
                        />
                    </Anchor>
                </div>
            </div>

            {/* Columna 3: Términos y Políticas */}
            <div className='footerText'>
                <h3>Términos y Políticas</h3>
                {politicasAMostrar.map((item) => (
                    <Anchor
                        key={item.idPolitica}
                        to={`/politicas?id=${item.idPolitica}`}
                        target="_self"
                        rel="noopener noreferrer"
                        className="footer-item-link"
                        title={item.titulo}
                    >
                        <FontAwesomeIcon icon={iconoPolitica(item)} className="footer-icon-accent" />
                        <span>{abreviarTitulo(item)}</span>
                    </Anchor>
                ))}
            </div>
        </div>
    )
}
